import type { News } from "../News.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getNewsDetailPath(news: Pick<News, "locale" | "urlSlug">): string {
	return getPathInLocale(news.locale, `/blog/${news.urlSlug}`);
}
